import getFieldPermission from '@ui-framework/helpers/getFieldPermission';
import getValueByDotNotation from '@ui-framework/helpers/getValueByDotNotation';

const generateLocaleId = label => {
  return label
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toUpperCase();
};

// Generate localization for validations
const validationLocalization = validations => {
  const newValidations = [];
  validations.forEach(({ message, fields, ...otherValidationProps }) => {
    // If fields is an array and has validations, process them recursively
    let processedFields = fields;
    if (Array.isArray(fields)) {
      processedFields = fields.map(field => {
        if (Array.isArray(field?.validations)) {
          return {
            ...field,
            validations: validationLocalization(field.validations),
          };
        }
        return field;
      });
    }
    const newValidation = {
      ...otherValidationProps,
      locale: {
        id: generateLocaleId(message),
        defaultMessage: message,
      },
    };
    if (processedFields) {
      newValidation.fields = processedFields;
    }
    newValidations.push(newValidation);
  });
  return newValidations;
};

/*
 * Generate Localication from label
 * Generate Placeholder from Label or use existing placeholder label
 * Add Permissions
 * Update Controls based on permissions
 * add validation scheme {locale: {id, defaultmessage}}
 */

const addFormSchemaEssentials = ({
  schema,
  permissions,
  userAccess,
  initialValues,
}) => {
  if (!Array.isArray(schema)) return schema;
  const newSchema = [];
  schema.forEach(field => {
    const newField = { ...field };

    newField.initialValue = getValueByDotNotation(initialValues, field?.name);

    const derivedPermission = getFieldPermission({
      field: newField,
      permissions,
    });

    if (derivedPermission === 'NO_PERMISSION') {
      return;
    }

    newField.permission = derivedPermission;

    if (field.label) {
      const localeId = generateLocaleId(field.label);
      newField.label = {
        localeId,
        defaultMessage: field.label,
      };
      let placeholder = `Please add ${field.label}`;
      if (field.placeholder) {
        placeholder = field.placeholder;
      }
      const localeIdPlaceholder = generateLocaleId(placeholder);
      newField.placeholder = {
        localeId: localeIdPlaceholder,
        defaultMessage: placeholder,
      };
    }

    if (newField.validations) {
      newField.validations = validationLocalization(newField.validations);
    }

    if (Array.isArray(field.children)) {
      newField.children = addFormSchemaEssentials({
        schema: field.children,
        permissions,
        userAccess,
        initialValues,
      });
    }
    newSchema.push(newField);
  });

  return newSchema;
};

export { addFormSchemaEssentials, validationLocalization, generateLocaleId };
